import React, { memo } from 'react';
import { Select } from 'antd';
import { indexes } from './config';
import BaseSelect from './BaseSelect';
import styles from './index.module.scss';

const SelectStreets = ({ options, value, propsRef, loading }) => {
  const onChange = (ids) => {
    const { value, onChange: changeHandler } = propsRef.current;
    const nextVal = ids?.length
      ? [ids, value[indexes.house], value[indexes.room]]
      : [[], [], []];
    changeHandler(nextVal);
  };

  return (
    <BaseSelect
      placeholder="Улицы"
      value={value}
      onChange={onChange}
      loading={loading}
    >
      {options?.map((item) => (
        <Select.Option
          key={item.id}
          searchtext={`${item.city}${item.name}`}
          value={item.id}
        >
          <div className={styles.accent}>{item.city}</div>
          {item.name}
        </Select.Option>
      ))}
    </BaseSelect>
  );
};

export default memo(SelectStreets);
